<script setup lang="ts">
const authStore = useAuthStore();
</script>

<template>

  <div
    class="
      relative flex-shrink-0 flex-col
      hidden
      md:flex
    ">

    <GenericPanel
      class="flex flex-col shadow-sm mb-3 pt-3 animate-fade-in opacity-0 [animation-delay:100ms]"
      :class="[authStore.isUser.cursed ? 'cursed' : '']">
      <LogoWord class="h-5 scale-90 mb-10 ml-2" />

      <UVerticalNavigation
        class="mb-2 mx-2 disabled:opacity-0"
        :links="topMenuLinks">

        <template #icon="{ link }">
          <UIcon
            :name="link.icon"
            class="size-5 mr-1"
            :class="[link.iconClass]" />
        </template>

        <!-- <template #icon="{ link }">
          <UChip
            inset
            class="mr-1"
            :show="false"
            color="red">
            <UIcon
              :name="link.icon"
              class="size-5"
              :class="[
                link.disabled ? 'opacity-50' : '',
                walletStore.synchronizing && link.key === 'wallets' ?
                  'animate-spin [animation-duration:700ms] opacity-50' :
                  '',
              ]" />
          </UChip>
        </template>

        <template #badge="{ link }">
          <UBadge
            v-if="link.badge"
            :label="link.badge"
            size="xs"
            color="white"
            variant="solid"
            class="relative ml-auto text-xs rounded-[4px]"
          />

          <UBadge
            v-if="link.scheduled"
            :label="link.scheduled"
            size="xs"
            color="white"
            variant="solid"
            class="flex relative ml-auto font-mono text-xs rounded-[4px]">
          </UBadge>
        </template>
 -->
      </UVerticalNavigation>

      <div class="flex items-center justify-between w-full mt-2 pl-4 pr-3 pb-2">
        <GenericFiatToggle />
        <UTooltip
          text="Gas Calculator"
          :open-delay="500"
          :popper="{ placement: 'top' }"
          :ui="{ base: 'font-medium' }">
          <UButton
            color="white"
            size="xs"
            @click="useGasCalculator().open()">
            <UIcon name="i-mdi-calculator" class="size-[1.125rem] rotate-3 text-gray-700 dark:text-gray-200" />
          </UButton>
        </UTooltip>
      </div>

    </GenericPanel>


    <!-- Global Panel -->
    <GenericPanel
      class="mb-3 animate-fade-in opacity-0 [animation-delay:200ms]"
      :class="[authStore.isUser.cursed ? 'cursed [animation-direction:alternate-reverse]' : '']">

      <div class="px-2 py-2">
        <UVerticalNavigation
          :links="bottomMenuLinks">

        <template #badge="{ link }">
          <UIcon
            v-if="link.target === '_blank'"
            name="i-tabler-external-link"
            class="ml-auto size-4 opacity-50" />
        </template>

        </UVerticalNavigation>
      </div>

      <!-- <UDivider class="mt-2" /> -->

      <div class="flex items-center justify-between pl-4 pr-2 py-2 mt-2">

        <UserIdentity />

        <UTooltip
          text="Logout"
          :open-delay="500"
          :popper="{ placement: 'top' }"
          :ui="{ base: 'font-medium' }">

          <UButton
            color="gray"
            variant="ghost"
            icon="i-tabler-logout"
            @click="authStore.logout()" />

        </UTooltip>
      </div>

    </GenericPanel>


    <div class="flex items-center justify-between">
      <ThemeToggle class="animate-fade-in opacity-0 [animation-delay:300ms]" />
    </div>

  </div>


</template>
